<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-create-update-class-school"
            @hidden="resetModal">
            
            <div class="container wrap-form-save-class-school">
                <h4>
                <strong>{{ getNameTitle }}</strong>
                </h4>
                <b-form id="form-save-class-school" @submit.prevent="handleSave">
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Tên trường:</label>
                                <b-form-input id="name" v-model="form.nameSchool" type="text" placeholder="Trường THPT Phan Đình Phùng"
                                    autocomplete="off"
                                    class="form-control" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.nameSchool.required && submitted">
                                    Vui lòng nhập tên trường
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group pb-2">
                        <div class="col-md-5">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Khối lớp:</label>
                                <b-form-select v-model="form.classId" :options="listDataClass" class="select-main-light">
                                    <option value="">Chọn lớp học</option>
                                </b-form-select>
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.classId.required && submitted">
                                    Vui lòng chọn lớp
                                </span>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Tên lớp:</label>
                                <b-form-input id="name" v-model="form.name" type="text" placeholder="Lớp 12A1"
                                    autocomplete="off"
                                    class="form-control" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.name.required && submitted">
                                    Vui lòng nhập tên lớp
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group pb-2">
                        <div class="col-md-5">
                            <label for="name">Môn học:</label>
                        </div>
                        <div class="col-md-7">
                            <div class="login-modal__form__item display-block">
                                <b-form-select v-model="form.subjectId" :options="listDataSubject" class="select-main-light">
                                    <option value="">Chọn môn học</option>
                                </b-form-select>
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.subjectId.required && submitted">
                                    Vui lòng chọn môn học
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form_action display-flex justity-content-space-between">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>
                        <button type="submit"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading">
                            {{ classSchoolId>0?'Cập nhật':'Thêm mới' }}
                        </button>
                    </div>
                </b-form>
            </div>           

        </b-modal>
        <ModalConfirmCreateUpdate v-if="classSchoolId == 0" ref="ModalConfirmCreateUpdate" :dataClassSchool="form"
            @handleDone="handleDone" />
    </div>
</template>

<script>
import { getAllTypeFilter, getAllClassFilter } from './../_api/'
import { required } from 'vuelidate/lib/validators';
import ModalConfirmCreateUpdate from './ModalConfirmCreateUpdate.vue'
import { getDetail,saveClassSchool,checkDuplicate } from './../_api/classSchoolServices'
export default {
    name: "ModalCreateUpdateClassSchool",
    props: {
        classSchoolId: {
            type: Number,
            default: 0
        }
    },
    components: {
        ModalConfirmCreateUpdate
    },
    watch: {
        'form.classId':'getTypesFilter'
    },
    data() {
        return {
            confirmActive: {},
            submitted: false,
            isLoading: false,
            listDataSubject: [],
            listDataClass: [],
            form: {
                id:0,
                nameSchool: '',
                code: '',
                name: '',
                password: '',
                classId: '',
                subjectId: '',
                className:'',
                subjectName:''
            }
        }
    },
    validations() {
        return {
            form: {
                nameSchool: {
                    required,
                },
                name: {
                    required,
                },
                subjectId: {
                    required
                },
                classId: {
                    required
                }
            }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        getNameTitle(){
            return this.classSchoolId==0?'Tạo lớp học':'Cập nhật lớp học'
        },
    },
    mounted() {
        //this.getTypesFilter()
        this.GetAllClass()
        this.handleShowModal()
        if(this.classSchoolId>0){
            this.getDetailClassSchool()
        }
    },

    methods: {
        
        getDetailClassSchool() {
            let self = this
            getDetail(this.classSchoolId).then(res => {
                if (res && res.data && !res.errors) {
                    self.form = {
                        id:res.data.id,
                        nameSchool: res.data.nameSchool,
                        code: res.data.code,
                        name: res.data.name,
                        password: res.data.password,
                        classId: res.data.classId,
                        subjectId: res.data.subjectId,

                    }
                }
            })
        },
        genCode() {
            let timestamp = new Date().getTime();
            let code = "LHC" + timestamp;
            return code
        },
        genPassword() {
            let timestamp = new Date().getTime();
            let password = "LHP" + timestamp;
            return password
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        handleSave() {
            let self = this
            this.submitted = true
            if (!this.$v.$invalid) {
                this.form.nameSchool = this.form.nameSchool.trim()
                this.form.name = this.form.name.trim()
                this.form.code = this.genCode()
                this.form.password = this.genPassword()
                checkDuplicate(this.form).then(res=>{
                    if (res && res.data && !res.errors)
                    {
                        if(res.data ==2){
                            self.$toast.error('Thông tin lớp đã bị trùng, vui lòng nhập lại')
                            return
                        }
                        if (self.classSchoolId == 0) {
                            for (let i = 0; i < this.listDataClass.length; i++) {
                                const item = this.listDataClass[i];
                                if(item.value == this.form.classId){
                                    this.form.className = item.text
                                    break
                                }
                            }
                            for (let i = 0; i < this.listDataSubject.length; i++) {
                                const item = this.listDataSubject[i];
                                if(item.value == this.form.subjectId){
                                    this.form.subjectName = item.text
                                    break
                                }
                            }
                            
                            self.$refs.ModalConfirmCreateUpdate.handleShowModal()
                        }
                        else{
                            saveClassSchool(self.form).then(rs=>{
                                if (rs && rs.data && !rs.errors) {
                                    self.$toast.success('Cập nhật lớp học thành công')
                                    self.handleDone()
                                }
                            })
                        }
                    }
                })
                

            }
        },
        resetModal() {
            console.log('resetModal')
            this.submitted = false
            this.form = {
                id:0,
                nameSchool: '',
                code: '',
                name: '',
                password: '',
                classId: '',
                subjectId: '',

            }
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-create-update-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-create-update-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-create-update-class-school'].show()
        },
        getTypesFilter() {
            let self = this
            self.listDataSubject = []
            getAllTypeFilter({classId:this.form.classId}).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                }
            })
        },
        GetAllClass() {
            let self = this
            self.listDataClass = []
            getAllClassFilter({}).then(res => {

                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name })
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-content {
    background-color: red;
}
.select-main-light{
    background-color: #e3effc;
    border: none;
    color:#3a68cb;
}
.wrap-form-save-class-school {
    padding-top: 20px;
    background-color: white;
    
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>